import React from 'react';
import ToolbarPopover from './ToolbarPopover';

const exportOptions = [
  {
    value: 'csv',
    label: 'CSV',
    description: 'Export as comma-separated values file',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    )
  },
  {
    value: 'xlsx',
    label: 'Excel',
    description: 'Export as Microsoft Excel file',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
      </svg>
    )
  }
];

const ExportPopover = ({
  id,
  open,
  anchorEl,
  onClose,
  onExportCSV,
  onExportXLSX
}) => {
  const handleExport = (format) => {
    if (format === 'csv') {
      onExportCSV();
    } else if (format === 'xlsx') {
      onExportXLSX();
    }
    onClose();
  };

  return (
    <ToolbarPopover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      title="Export Data"
    >
      <div className="p-4">
        <div className="space-y-3">
          {exportOptions.map(option => (
            <div
              key={option.value}
              onClick={() => handleExport(option.value)}
              className="relative flex items-center p-3 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors duration-150"
            >
              <div className="flex-shrink-0 text-gray-500">
                {option.icon}
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-900">
                  {option.label}
                </p>
                <p className="text-sm text-gray-500">
                  {option.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </ToolbarPopover>
  );
};

export default React.memo(ExportPopover);
